<template>
<!--考试成绩-->
  <div id="examscore">
    <h2 class="title">
      <a @click="back()" class="prev"></a>
      考试成绩
      <a href="" class="share">
        <img src="../../assets/icon/examscore_icon_share.png" alt="">
      </a>
    </h2>
    <h1>恭喜成功完成考试</h1>
    <div class="score">
      <h3><b>{{score}}</b>分</h3>
      <h6>本次成绩</h6>
    </div>
    <div class="result">
      <p>
        共5题，答对1题，正确率{{score}}，满分100分
      </p>
    </div>
    <div class="redo">
      <router-link :to="{name: 'ExamBank'}" class="returnlist">返回列表</router-link>
      <a @click="gotoWrongBank" class="check">查看错题</a>
    </div>
    <!--精品课程-->
    <div id="jpkc">
      <div class="title">
        <h3>精品课程</h3>
        <h6>已有 <span>6</span> <span>5</span> <span>2</span> <span>0</span> 名学员</h6>
        <p>学习以下课程通过考试</p>
        <a href="" class="arrow"></a>
      </div>
      <div class="main">
        <div class="left"><img :src="recommendData.app_img_1" alt=""></div>
        <div class="right">
          <h4>{{recommendData.name}}</h4>
          <p>
            {{recommendData.name_main}}
          </p>
          <div class="xx">学习：<b>{{recommendData.sum_price}}人</b></div>
          <div class="ks">课时：<b>{{recommendData.hours}}</b></div>
          <router-link :to="{name: 'ClassDetailTeacher', query: {class_id: recommendData.class_id}}" class="bmst">报名试听</router-link>
        </div>
      </div>
      <router-link :to="{name: 'Jsbs'}" class="ckqb">查看全部</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExamScore',
  data () {
    return {
      score: this.$route.query.score ? this.$route.query.score : 0,
      subject: this.$store.state.subject ? this.$store.state.subject : 1, // 1 教师资格证-笔试 、 2 教师资格证-面试、3 教师招聘-笔试、4 教师招聘-面试、1,2 教师资格证、3,4 教师招聘 多个使用,号拼接
      period: this.$store.state.period ? this.$store.state.period : 2, // 学段 1中学 2小学 3幼儿  多个使用,号拼接
      recommendData: {}
    }
  },
  methods: {
    back () {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    },
    // 获得推荐课程
    getRecommend () {
      let data = {
        page: 1,
        subject: this.subject,
        period: this.period
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_question_recommend_course',
        params: data,
        headers: {
          'sign': this.$encryption(data)
        }
      })
        .then(res => {
          console.log(res)
          this.recommendData = res.data.data
        })
        .catch(err => { console.log(err) })
    },
    gotoWrongBank () {
      this.$router.push({name: 'WrongBank'})
    }
  },
  mounted () {
    this.getRecommend()
  }
}
</script>

<style scoped lang="stylus">
  #examscore
    @import "../../assets/stylus/examHead"
    h2.title
      border-bottom: .02rem solid #E7E8E9
    h1
      margin: .3rem 0
      font-size: .4rem
      color: #333
      font-weight: 600
      text-align: center
    .score
      width: 7.5rem
      height: 4.34rem
      background: url(../../assets/img/examscore_bg_score.png) no-repeat center
      -webkit-background-size: 4.4rem 4.34rem
      background-size: 4.4rem 4.34rem
      overflow: hidden
      h3
        margin: 1.18rem 0 0
        font-size: .4rem
        color: #fff
        text-align: center
        b
          font-size: .7rem
      h6
        margin: .98rem 0 0
        font-size: .36rem
        color: #5C3A15
        font-weight: 600
        text-align: center
    .result
      p
        margin: .4rem 0 0
        font-size: .28rem
        text-align: center
        color: #8A88A1
    .redo
      display: flex
      justify-content: space-between
      align-items: center
      width: 5.2rem
      height: .72rem
      margin: .6rem auto
      a
        display: inline-block
        width: 2.4rem
        height: .72rem
        line-height: .68rem
        border: .02rem solid #FF7052
        background-color: #FF7052
        font-size: .32rem
        color: #fff
        text-align: center
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        -webkit-border-radius: .4rem
        -moz-border-radius: .4rem
        border-radius: .4rem
        &.check
          background-color: transparent
          color: #666
    #jpkc
      width: 7.1rem
      height: 5.98rem
      background-color: #fff
      margin: .32rem auto
      -webkit-border-radius: .16rem
      -moz-border-radius: .16rem
      border-radius: .16rem
      .title
        position: relative
        overflow: hidden
        width: 100%
        height: 1.88rem
        background: url(../../assets/img/ home_jpkc_bg_title.png) no-repeat center
        -webkit-background-size: 100%
        background-size: 100%
        h3
          margin: .2rem
          font-size: .36rem
          color: #fff
          text-align: left
        h6
          font-size: .28rem
          color: #252E4C
          text-align: center
          span
            display: inline-block
            width: .36rem
            height: .36rem
            line-height: .36rem
            background-color: #252E4C
            font-size: .32rem
            color: #fff
            text-align: center
        h6 + p
          line-height: .56rem
          font-size: .4rem
          color: #FF7052
          font-weight: 500
          text-align: center
        a.arrow
          position: absolute
          top: .2rem
          right: .2rem
          display: block
          width: .44rem
          height: .44rem
          background: url(../../assets/img/home_jpkc_arrow.png) no-repeat center
          -webkit-background-size: 100%
          background-size: 100%
      .main
        display: flex
        justify-content: space-between
        width: 6.7rem
        height: 2.24rem
        margin: .32rem auto
        .left
          width: 2.28rem
          height: 2.24rem
          -webkit-border-radius: .08rem
          -moz-border-radius: .08rem
          border-radius: .08rem
          img
            width: 100%
        .right
          position: relative
          width: 4.22rem
          height: 2.24rem
          h4
            line-height: .5rem
            font-size: .36rem
            color: #0C0C0C
            font-weight: bold
            text-align: center
          p
            line-height: .45rem
            font-size: .24rem
            color: #9DA4B3
            text-align: left
          div.xx
            display: none
            line-height: .4rem
            font-size: .25rem
            color: #9DA4B3
            b
              font-size: .3rem
          div.ks
            line-height: .4rem
            font-size: .25rem
            color: #9DA4B3
            b
              font-size: .3rem
              color: #FF7052
          a.bmst
            position: absolute
            bottom: 0
            right: 0
            display: block
            width: 1.52rem
            height: .56rem
            line-height: .56rem
            background-color: #FF7052
            font-size: .24rem
            color: #fff
            text-align: center
            -webkit-border-radius: .34rem
            -moz-border-radius: .34rem
            border-radius: .34rem
      a.ckqb
        display: block
        width: 6.7rem
        height: .88rem
        line-height: .88rem
        background-color: #F4F3F1
        margin: 0 auto
        font-size: .28rem
        color: #FF7052
        text-align: center
        -webkit-border-radius: .16rem
        -moz-border-radius: .16rem
        border-radius: .16rem
</style>



// WEBPACK FOOTER //
// src/components/exam/ExamScore.vue